import { derived, writable } from 'svelte/store';
export const pegA = writable([]);
export const pegB = writable([]);
export const pegC = writable([]);
export const movesCount = writable(0);
export const console = writable([]);
export const isIterationFinished = writable(false);
export const isFreshData = writable(true);
export const isDataPresent = derived([pegA, pegB, pegC], ([$pegA, $pegB, $pegC]) => $pegA.length > 0 || $pegB.length > 0 || $pegC.length > 0);
export const canExecuteIteration = derived([isIterationFinished, isDataPresent], ([$isIterationFinished, $isDataPresent]) => !$isIterationFinished && $isDataPresent);
